export const formatKeyLabel = (key: string, toUpperCase = false): string => {
  if (!key || typeof key !== 'string') return ''

  const spaced = key
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2') // handles camelCase
    .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2') // handles acronyms

  return toUpperCase
    ? spaced.toUpperCase()
    : spaced.replace(/^./, (str) => str.toUpperCase())
}

export const samepleUserActivityData = [
  {
    eventKey: 1,
    eventGroupKey: 'd4bb5a64-1a15-4259-b27c-a24995bbf3c9',
    actionType: 2,
    eventTimeStamp: '2026-04-15T22:30:00.0000000Z',
    heading: 'Added user',
    userName: 'Anoop',
    userRole: 'LM Supervisor',
    applicationName: 'Coordinator Web App',
    previousInfo: {},
    newInfo: {
      username: 'John',
      phoneNo: '56768',
      email: 'john@example.com',
      coordinatorWebRole: 'LM Supervisor',
      coordinatorMobileRole: 'Coordinator',
      status: 'Active',
    },
    keys: ['username', 'phoneNo', 'email', 'status'],
    roles: [
      {
        applicationName: 'LastMileApp',
        roleNameFrom: '',
        roleNameTo: 'LM Supervisor',
      },
      {
        applicationName: 'Coordinator Mobile App',
        roleNameFrom: '',
        roleNameTo: 'LM Supervisor',
      },
    ],
    temporaryRoles: [
      {
        applicationName: 'LastMileApp',
        roleNameFrom: '',
        roleNameTo: 'LM Manager',
        startTimeFrom: '2026-04-15T22:30:00.0000000Z',
        endTimeFrom: '',
        statusFrom: 'Active',
        startTimeTo: '2026-04-15T22:30:00.0000000Z',
        endTimeTo: '2026-04-15T22:30:00.0000000Z',
        statusTo: 'Active',
      },
      {
        applicationName: 'Coordinator Mobile App',
        roleNameFrom: 'Coordinator',
        roleNameTo: 'Coordinator Supervisor',
        startTimeFrom: '',
        endTimeFrom: '',
        statusFrom: 'Active',
        startTimeTo: '2026-04-15T22:30:00.0000000Z',
        endTimeTo: '2026-04-15T22:30:00.0000000Z',
        statusTo: 'Active',
      },
    ],
    timeStampKeys: [],
    eventData: [
      {
        label: 'Username',
        value: 'John',
        type: 'string',
      },
      {
        label: 'Phone No.',
        value: '56768',
        type: 'int32',
      },
      {
        label: 'Email',
        value: 'john@example.com',
        type: 'string',
      },
      {
        label: 'Coordinator Web Role',
        value: 'LM Supervisor',
        type: 'string',
      },
      {
        label: 'Coordinator Mobile Role',
        value: 'Coordinator',
        type: 'string',
      },
      {
        label: 'Status',
        value: 'Active',
        type: 'string',
      },
    ],
  },
  {
    eventKey: 2,
    eventGroupKey: 'd4bb5a64-1a15-4259-b27c-a24995bbf3c9',
    actionType: 0,
    eventTimeStamp: '2026-04-15T22:30:00.0000000Z',
    heading: 'Changed the data',
    userName: 'Anoop',
    userRole: 'LM Supervisor',
    applicationName: 'Coordinator Web App',
    previousInfo: {
      username: 'John',
      phoneNo: '12345',
      coordinatorWebRole: 'LM Manager',
    },
    newInfo: {
      username: 'John Mayor',
      phoneNo: '56768',
      coordinatorWebRole: 'LM Supervisor',
    },
    keys: ['username', 'phoneNo', 'coordinatorWebRole'],
    eventData: [
      {
        label: 'Username',
        value: 'John Mayor',
        type: 'string',
      },
      {
        label: 'PhoneNo.',
        value: '56768',
        type: 'int32',
      },
      {
        label: 'Coordinator Web Role',
        value: 'LM Supervisor',
        type: 'string',
      },
    ],
    timeStampKeys: [],
  },
  {
    eventKey: 3,
    eventGroupKey: 'c565416b-4dc4-4d58-afb5-54473ca2a607',
    actionType: 0,
    eventTimeStamp: '2026-04-15T22:30:00.0000000Z',
    heading: 'Changed the data',
    userName: 'Divyanshi',
    userRole: 'LM Supervisor',
    applicationName: 'Coordinator Web App',
    previousInfo: {
      status: 'Active',
    },
    newInfo: {
      status: 'Inactive',
    },
    keys: ['status'],
    eventData: [
      {
        label: 'Status',
        value: 'Inactive',
        type: 'string',
      },
    ],
    timeStampKeys: [],
  },
  {
    eventKey: 4,
    eventGroupKey: 'e90c565c-210b-4652-8e86-b0e3aad55b92',
    actionType: 0,
    eventTimeStamp: '2026-04-15T22:30:00.0000000Z',
    heading: 'Changed the data',
    userName: 'Dipak',
    userRole: 'LM Supervisor',
    applicationName: 'Coordinator Web App',
    previousInfo: {},
    newInfo: {
      temporaryRoleAssignment: 'Full Admin',
      startTime: '04/20/2026 5:30:00 PM',
      endTime: '04/21/2026 5:30:00 PM',
    },
    keys: ['temporaryRoleAssignment', 'startTime', 'endTime'],
    eventData: [
      {
        label: 'Temporary Role Assignment',
        value: 'Full Admin',
        type: 'string',
      },
      {
        label: 'Start Time',
        value: '04/20/2026 5:30:00 PM',
        type: 'timestamp',
      },
      {
        label: 'End Time',
        value: '04/21/2026 5:30:00 PM',
        type: 'timestamp',
      },
    ],
    timeStampKeys: ['startTime', 'endTime'],
  },
  {
    eventKey: 5,
    eventGroupKey: '9575d546-4bfc-4b86-a1a3-d9f15d8ee36b',
    actionType: 0,
    eventTimeStamp: '2026-04-15T22:30:00.0000000Z',
    heading: 'Changed the data',
    userName: 'Anoop',
    userRole: 'LM Supervisor',
    applicationName: 'Coordinator Web App',
    previousInfo: {
      endTime: '04/21/2026 5:30:00 PM',
    },
    newInfo: {
      endTime: '04/21/2026 7:30:00 PM',
    },
    keys: ['endTime'],
    eventData: [
      {
        label: 'End Time',
        value: '04/21/2026 7:30:00 PM',
        type: 'timestamp',
      },
    ],
    timeStampKeys: ['endTime'],
  },
  {
    eventKey: 6,
    eventGroupKey: '53de269e-5bfe-4724-8cbd-acdb9fb0e9de',
    actionType: 0,
    eventTimeStamp: '2026-04-15T22:30:00.0000000Z',
    heading: 'System changed the data',
    userName: 'system',
    previousInfo: {
      temporaryRoleAssignment: 'Full Admin',
    },
    newInfo: {
      temporaryRoleAssignment: 'None',
    },
    keys: ['temporaryRoleAssignment'],
    eventData: [
      {
        label: 'Temporary Role Assignment',
        value: 'None',
        type: 'string',
      },
    ],
    timeStampKeys: [],
  },
]
